import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MdDialogRef} from '@angular/material';
import {RequestSupportButtonComponent} from '../request-support/request-support-button.component';
import {FormUtilities} from '../../FormUtilities';

@Component({
  selector: 'app-request-support-dialog',
  templateUrl: './request-support-dialog.component.html',
  styleUrls: ['./request-support-dialog.component.scss']
})
export class RequestSupportDialogComponent implements OnInit {
  requestSupportForm: FormGroup;
  public minLength = 30;
  public maxLength = 1500;


  constructor(public dialogRef: MdDialogRef<RequestSupportButtonComponent>,
              public formUtils: FormUtilities) { }

  ngOnInit() {
      this.requestSupportForm = new FormGroup({
        name: new FormControl('', Validators.required),
        email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
        issue: new FormControl('', Validators.compose([
          Validators.required,
          Validators.maxLength(this.maxLength),
          Validators.minLength(this.minLength)
        ]))
      });
  }

  onSubmit() {
    const formValue = this.requestSupportForm.value;
    this.dialogRef.close(formValue);
  }

  isInvalidAndTouched(formControlName: string) {
    return this.formUtils.isInvalidAndTouched(this.requestSupportForm, formControlName);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/request-support-dialog/request-support-dialog.component.ts